import { UserEvent } from '@/types/eventhandler';
import { Prompt, PromptSortType } from '@/types/prompt';
import { Subroutine, SubroutineFolder, SubroutineSortType } from '@/types/subroutine';
import { Variable, VariableSortType } from '@/types/variable';
import { isString } from '@/util/typeGuards';

export const sortPrompts = (
  filteredPrompts: Prompt[] | undefined,
  sortBy: PromptSortType,
  invert: boolean,
  defaultSort: string
) => {
  const getSortKey = (item: any) => {
    return isString(item[sortBy]) ? item[sortBy] || item[defaultSort] : item[sortBy].name || item[defaultSort];
  };

  return invert
    ? filteredPrompts?.toSorted((a, b) => getSortKey(a)?.localeCompare(getSortKey(b))).reverse()
    : filteredPrompts?.toSorted((a, b) => getSortKey(a)?.localeCompare(getSortKey(b)));
};

export const sortSubroutines = (sortBy?: SubroutineSortType, items?: Subroutine[]) => {
  if (!items || !sortBy) return;
  switch (sortBy) {
    case 'up':
      return items?.sort((a, b) => b.label.localeCompare(a.label));
    case 'down':
      return items?.sort((a, b) => a.label.localeCompare(b.label));
    default:
      return items;
  }
};

export const sortSubroutineFolders = (sortBy?: SubroutineSortType, items?: SubroutineFolder[]) => {
  if (!items || !sortBy) return;
  switch (sortBy) {
    case 'up':
      return items?.sort((a, b) => b.label.localeCompare(a.label));
    case 'down':
      return items?.sort((a, b) => a.label.localeCompare(b.label));
    default:
      return items;
  }
};

export const sortVariables = (variables: Variable[], sortBy: VariableSortType, invert: boolean): Variable[] => {
  switch (sortBy) {
    case 'name':
      return invert
        ? variables.toSorted((a, b) => b.name.localeCompare(a.name))
        : variables.toSorted((a, b) => a.name.localeCompare(b.name));

    case 'date':
      return invert ? variables : variables.toReversed();

    default:
      return variables;
  }
};

export const sortUserEvents = (userEvents: UserEvent[], sortBy: 'event' | 'label', invert: boolean): UserEvent[] => {
  return invert
    ? userEvents.toSorted((a, b) => b[sortBy].localeCompare(a[sortBy]))
    : userEvents.toSorted((a, b) => a[sortBy].localeCompare(b[sortBy]));
};

export const filterUserEventsByQuery = (records: UserEvent[], query: string): UserEvent[] =>
  records?.filter(
    (userEvent) =>
      userEvent.event.toLowerCase().includes(query?.toLowerCase()) ||
      userEvent.label.toLowerCase().includes(query?.toLowerCase())
  );

export const filterByQuery = (records: Variable[], query: string): Variable[] =>
  records?.filter((variable) => variable.name?.toLowerCase().includes(query?.toLowerCase()));
